import {useState, useEffect, useContext} from 'react';
import {UserContext} from "../../App"
import {useCookies, Cookies} from "react-cookie"
import {Connexion} from "./Connexion"
import {Menu} from "./Menu"
import {Onglet} from "./Onglet"
import {Chargement} from "./Chargement"
import {BugConnexion} from "../config/BugConnexion"


export function Compte ({menu, setMenu}) {
  const [onglet, setOnglet] = useState('Gestion')
  document.title = 'Compte' + ('GestionQuestionsDonnerCréerMes sériesRetrouverLes erreurs'.includes(onglet) ? ' - ' + onglet : '')
  const [loading, setLoading] = useState(false)
  const [classe, setClasse] = useState('')
  const [msg, setMsg] = useState('')
  const [bugConnexion, setBugConnexion] = useState(false)
  const [fields, setFields] = useState({
    identifiant:'',
    mdp:''
  })

  // =============== Authentification  ===============
  const [cookies, setCookie] = useCookies(['nom', 'prenom', 'classe'])
  const cook = new Cookies();
  const expirationDate = new Date();
  expirationDate.setFullYear(expirationDate.getFullYear() + 1);

  const {currentUser, setCurrentUser} = useContext(UserContext)

  const auth = { 
    nom:cook.get("nom"),
    prenom:cook.get("prenom"),
    mdp:cook.get("mdp"),
  }

  useEffect(()=>{
    if(currentUser.nom) {
      fetch("https://maths-au-quotidien.fr/react-automaths/api.php", {
        method: 'POST',
        body: JSON.stringify(auth)
      })
      .then(response => response.json())
      .then(data => {
        //console.log(data)
        setCurrentUser(data)
        //setUser(data)
        //data.profil == 'Professeur' ? setMenu(['Gestion', 'Mes devoirs', 'Aléatoire', 'Choisir', 'Mes séries', 'Créer', 'Différencier'].concat(data.liste_classes)) : setMenu(['Mes devoirs', 'Mes essais', 'Mes stats'])
        data.profil === 'Professeur' ? setMenu(['Gestion', 'Questions'].concat(data.liste_classes)) : setMenu(['Mes devoirs', 'Mes essais', 'Mes erreurs', 'Mes stats', 'Utilisation'])
      })
      .catch(err => {
        setBugConnexion(true)
        console.log(err)
      })
    }
  },[]);


  const handleClick = (e) => {
    const name = e.target.attributes.name.nodeValue
    setOnglet(name)
    setClasse(name)
    let tab_sous_menu = ['Gestion', 'Questions', 'Donner', 'Les erreurs', 'Mes séries', 'Créer', 'Retrouver']
    /*
    if(currentUser.statut === 'admin_314159') {tab_sous_menu.push('Les erreurs')}
    */
    if('QuestionsMes devoirsDonnerCréerMes sériesRetrouverLes erreurs'.includes(name) && currentUser.profil === 'Professeur') {
      //setMenu(['Gestion', 'Mes devoirs', 'Donner', 'Créer', 'Mes séries', 'Question', 'Erreurs'].concat(currentUser.liste_classes)) 
      setMenu(tab_sous_menu.concat(currentUser.liste_classes)) 
    } else if(currentUser.profil === 'Professeur'){
      setMenu(['Gestion', 'Questions'].concat(currentUser.liste_classes))
    }
  }

  const handleSubmit = (e) => {
    if(!fields.identifiant || !fields.mdp) {
      setMsg('<span class="alert danger fadeout5"> <br>Veuillez remplir tous les champs.<br><br></span>')
        setTimeout(e => {setMsg('')}, 6000)
      return
    }
    setLoading(true)
    /*const auth = {
      nom:fields.identifiant.split('.')[1]?.toUpperCase(),
      prenom:fields.identifiant.split('.')[0][0].toUpperCase()+fields.identifiant.split('.')[0].slice(1).toLowerCase(),
      mdp:fields.mdp,
      action:'auth'
    }*/
    fetch("https://maths-au-quotidien.fr/react-automaths/api.php", {
        method: 'POST',
        body: JSON.stringify({
          nom:fields.identifiant.split('.')[1]?.toUpperCase(),
          prenom:fields.identifiant.split('.')[0][0].toUpperCase()+fields.identifiant.split('.')[0].slice(1).toLowerCase(),
          mdp:fields.mdp,
          action:'auth'
        })
      })
      .then(response => response.json())
      .then(data => {
        setCookie(['nom'], data.nom, { path: '/', expires: expirationDate })
        setCookie(['prenom'], data.prenom, { path: '/', expires: expirationDate })
        setCookie(['mdp'], data.mdp, { path: '/', expires: expirationDate })
        //setCookie(['nom'], data.nom, { domain: 'maths-au-quotidien.fr', path: '/' })
        //setCookie(['prenom'], data.prenom, { domain: 'maths-au-quotidien.fr', path: '/' })
        //setCookie(['mdp'], data.mdp, { domain: 'maths-au-quotidien.fr', path: '/' })

        setCurrentUser(data)
        //setUser(data)

        data.profil === 'Professeur' ? setMenu(['Gestion', 'Questions'].concat(data.liste_classes)) : setMenu(['Mes devoirs', 'Mes essais', 'Mes erreurs', 'Mes stats', 'Utilisation'])
        setLoading(false)
      })
      .catch(err => {
        setLoading(false)
        setMsg('<span class="alert danger fadeout5"> <br>Compte inexistant ou erreur de mot de passe<br><br></span>')
        setTimeout(e => {setMsg('')}, 6000)
      })
  }

  //console.log(currentUser)
  return (
    loading ? 
      <div className="login">
        <div className="cadre cadre_titre">Connexion à l'espace membres</div>
        <Chargement />
      </div> 
    :
      <div>
      	{!currentUser.nom && !loading ? <Connexion handleSubmit={handleSubmit} setFields={setFields} fields={fields} msg={msg} /> : ''}
        
        {bugConnexion && <BugConnexion/>}  

        {currentUser.profil ? <Menu menu={menu} handleClick={handleClick} onglet={onglet} /> : ''}

        {currentUser.nom ? <Onglet user={currentUser} onglet={onglet} classe={classe} setUser={setCurrentUser} setMenu={setMenu} /> : ''}

      </div>
  );
}
